var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 28.0001C4.66699 17.0006 4.66699 11.5009 8.08408 8.08384C11.5012 4.66675 17.0009 4.66675 28.0003 4.66675C38.9998 4.66675 44.4995 4.66675 47.9166 8.08384C51.3337 11.5009 51.3337 17.0006 51.3337 28.0001C51.3337 38.9995 51.3337 44.4992 47.9166 47.9163C44.4995 51.3334 38.9998 51.3334 28.0003 51.3334C17.0009 51.3334 11.5012 51.3334 8.08408 47.9163C4.66699 44.4992 4.66699 38.9995 4.66699 28.0001Z",
    stroke: "#AEBEF4",
    strokeWidth: 2.91667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 42V21",
    stroke: "#AEBEF4",
    strokeWidth: 2.91667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 42V14",
    stroke: "#AEBEF4",
    strokeWidth: 2.91667,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.667 41.9999V30.3333",
    stroke: "#AEBEF4",
    strokeWidth: 2.91667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.650ceaab6921a02bbdb7f88643c2a1c1.svg";
export { ForwardRef as ReactComponent };